import styled from 'styled-components'
import { INTER } from '@styles/fonts'
import { BLACK, NEUTRAL_300 } from '@styles/colors'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: white;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 16px;
  gap: 8px;
  overflow-y: auto;
`

export const SectionLabel = styled.div`
  font-family: ${INTER.semiBold};
  font-size: 14px;
  color: ${NEUTRAL_300};
`

export const ProviderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`

export const ProviderLabel = styled.div`
  font-family: ${INTER.medium};
  font-size: 11px;
  color: ${BLACK};
  text-align: center;
`
